import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { FaEdit } from 'react-icons/fa';
import { IoDuplicate } from 'react-icons/io5';
import { API } from '../../api/Api';
import VisualizerDropDown from '../components/Dropdowns/VisualizerDropDown';
import GrainDropDown from '../components/Dropdowns/GrainDropDown';
import StyleTypeDropDown from '../components/Dropdowns/StyleTypeDropDown';
import { BeatLoader } from 'react-spinners';
import { Toaster } from 'react-hot-toast';
import { toast } from 'react-toastify';
import { GrNext, GrPrevious } from 'react-icons/gr';

const AngleView = () => {
    const token = localStorage.getItem('token');
    const [apiData, setApiData] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [grainTypes, setGrainTypes] = useState([]);
    const [styleTypes, setStyleTypes] = useState([]);
    const [angleToDelete, setAngleToDelete] = useState(null);
    const [modalImage, setModalImage] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const [showDuplicateModal, setShowDuplicateModal] = useState(false);
    const [rowToDuplicate, setRowToDuplicate] = useState(null);

    const { id } = useParams();

    const fetchVisualizerDetails = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getvisualizerdetail';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { visualizer_id: id };

        try {
            setLoading(true);
            const response = await API(url, requestBody, token);
            if (response) {
                setApiData(response.Result_value);
            }
        } catch (error) {
            console.error('Error during authentication:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchGrainTypes = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getvisualizermasterlist'; // Replace with your actual API endpoint
        const url = `${baseURl}${apiPath}`;
        const requestBody = { type: "grain" };

        try {
            const response = await API(url, requestBody, token);
            if (response) {
                return response.Data; // Assuming the response contains the list of grain types
            }
        } catch (error) {
            console.error('Error fetching grain types:', error);
        }
    };

    const fetchStyleTypes = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getvisualizermasterlist'; // Replace with your actual API endpoint
        const url = `${baseURl}${apiPath}`;
        const requestBody = { type: "styletype" };

        try {
            const response = await API(url, requestBody, token);
            if (response) {
                return response.Data; // Assuming the response contains the list of style types
            }
        } catch (error) {
            console.error('Error fetching style types:', error);
        }
    };


    useEffect(() => {
        fetchVisualizerDetails();

        const fetchData = async () => {
            const grainTypesData = await fetchGrainTypes();
            const styleTypesData = await fetchStyleTypes();

            if (grainTypesData) {
                setGrainTypes(grainTypesData);
            }
            if (styleTypesData) {
                setStyleTypes(styleTypesData);
            }
        };

        fetchData();
    }, []);

    const getGrainTypeName = (id) => {
        const grainType = grainTypes.find(type => type.id == id);
        return grainType ? grainType.name : id;
    };

    const getStyleTypeName = (id) => {
        const styleType = styleTypes.find(type => type.id == id);
        return styleType ? styleType.name : id;
    };


    const navigate = useNavigate();

    const [angleData, setAngleData] = useState([
        { id: 1, angle: "Angle 1", grainType: "Horizontal", styleType: "Slab", status: "Active" },
        { id: 2, angle: "Angle 2", grainType: "Vertical", styleType: "Slim shaker", status: "Inactive" },
        { id: 3, angle: "Angle 3", grainType: "Horizontal", styleType: "Slab", status: "Active" },
    ]);

    const [showModal, setShowModal] = useState(false);
    const [newAngle, setNewAngle] = useState({
        id: 0,
        angle: "",
        visualizertype_id: "",
        default_grain_id: "",
        default_style_type_id: "",
        baseImage: null,
        baseImagePath: null,
        svgImage: null,
        svgImagePath: null,
        status: "Active"
    });

    const handleAddAngle = async () => {
        const newErrors = {};

        if (!newAngle.angle) newErrors.angle = 'Angle name is required';
        if (!newAngle.default_grain_id) newErrors.default_grain_id = 'Grain type is required';
        if (!newAngle.default_style_type_id) newErrors.default_style_type_id = 'Style type is required';
        if (!newAngle.baseImage && !newAngle.baseImagePath) newErrors.baseImage = 'Base image is required';
        if (!newAngle.svgImage && !newAngle.svgImagePath) newErrors.svgImage = 'SVG image is required';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);

        const url = `${process.env.REACT_APP_API_URL}/visualizer/createupdateangle`;

        const formData = new FormData();
        formData.append('id', newAngle.id);
        formData.append('name', newAngle.angle);
        formData.append('visualizer_id', id);
        formData.append('key', '');
        formData.append('default_grain_id', newAngle.default_grain_id);
        formData.append('default_style_type_id', newAngle.default_style_type_id);

        // Handle base image
        if (newAngle.baseImage instanceof File) {
            formData.append('base_image', newAngle.baseImage);
            formData.append('base_image_path', ''); // Set base_image_path to empty if a new file is uploaded
        } else {
            formData.append('base_image', ''); // Send empty base_image parameter if no new file is uploaded
            formData.append('base_image_path', newAngle.baseImagePath || ''); // Send existing base_image_path
        }

        // Handle SVG image
        if (newAngle.svgImage instanceof File) {
            formData.append('svg_image', newAngle.svgImage);
            formData.append('svg_image_path', ''); // Set svg_image_path to empty if a new file is uploaded
        } else {
            formData.append('svg_image', ''); // Send empty svg_image parameter if no new file is uploaded
            formData.append('svg_image_path', newAngle.svgImagePath || ''); // Send existing svg_image_path
        }

        formData.append('status', newAngle.status === "Active" ? 1 : 0);

        try {
            setLoading(true);

            const response = await API(url, formData, token, 'multipart/form-data');
            if (response && response.Result == 1) {
                toast.success(newAngle.id === 0 ? "Angle Added successfully" : "Angle Updated successfully");
                setShowModal(false);
                fetchVisualizerDetails();
            }
        } catch (error) {
            toast.error("Error during adding/updating angle");
            console.error('Error during adding/updating angle:', error);
        } finally {
            setLoading(false);
        }
    };


    const handleEditClick = (angle) => {
        setNewAngle({
            id: angle.id,
            angle: angle.name,
            visualizertype_id: angle.visualizer_id,
            default_grain_id: angle.default_grain_id,
            default_style_type_id: angle.default_style_type_id,
            baseImage: null, // You might want to handle image previews separately
            baseImagePath: angle.base_image, // You might want to handle image previews separately
            svgImage: null, // You might want to handle image previews separately
            svgImagePath: angle.svg_image, // You might want to handle image previews separately
            status: angle.status ? "Active" : "Inactive"
        });
        setShowModal(true); // Open the modal
    };

    const handleGrainSelect = (default_grain_id) => {
        setNewAngle((prevData) => ({
            ...prevData,
            default_grain_id: default_grain_id || "",
        }));
    };

    const handleStyleTypeSelect = (default_style_type_id) => {
        setNewAngle((prevData) => ({
            ...prevData,
            default_style_type_id: default_style_type_id || "",
        }));
    };

    const handleDeleteAngle = async (angleId) => {
        const url = `${process.env.REACT_APP_API_URL}/visualizer/deletevisualizerangle`;
        try {
            setLoading(true);
            const response = await API(url, { id: angleId }, token);
            if (response?.Result === 1) {
                toast.success("Angle deleted successfully!");
                fetchVisualizerDetails(); // Refresh list
            } else {
                toast.error("Failed to delete angle.");
            }
        } catch (err) {
            console.error("Delete Angle Error:", err);
            toast.error("Something went wrong.");
        } finally {
            setAngleToDelete(null); // close modal
            setLoading(false);
        }
    };

    const openModal = (imageSrc) => {
        setModalImage(imageSrc);
    };

    const totalPages = Math.ceil((apiData?.VisualizerAngles?.length || 0) / itemsPerPage);
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentAngles = apiData?.VisualizerAngles?.slice(indexOfFirst, indexOfLast) || [];

    const handleDuplicateAngle = async (angleId) => {
        const url = `${process.env.REACT_APP_API_URL}/visualizer/duplicateangle`;

        try {
            setLoading(true);
            const response = await API(url, { angle_id: angleId }, token);

            if (response?.Result === 1) {
                toast.success("Angle duplicated successfully!");
                fetchVisualizerDetails(); // reload data
            } else {
                toast.error("Failed to duplicate angle");
            }
        } catch (err) {
            console.error("Duplicate Angle Error:", err);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
            setShowDuplicateModal(false);
            setRowToDuplicate(null);
        }
    };



    return (
        <>
            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/80">
                    <BeatLoader size={20} />
                </div>
            )}

            <Toaster position="top-center" />
            <div className="flex h-screen fixed w-full">
                <div className="md:w-64 w-16 bg-black transition-all">
                    <Sidebar />
                </div>
                <div className="flex flex-col flex-1 min-h-full">
                    <div className="bg-gray-100 flex-1 p-4 overflow-auto min-h-full">
                        <div className="bg-white rounded-2xl w-full flex flex-col min-h-full">
                            {/* Header */}
                            <div className="flex justify-between items-center px-6 pt-4">
                                <p className="text-teal-500 text-xl font-semibold">Angle Views of {apiData.name}</p>
                                <button
                                    onClick={() => navigate('/admin/layouts')}
                                    className="bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded px-4 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                >
                                    Back
                                </button>
                            </div>
                            <hr className="border-gray-200" />

                            {/* Add Angle Button */}
                            <div className="flex justify-end px-6 mt-4">
                                {/* <h1 className='font-semibold text-lg'>All Angles</h1> */}
                                <button
                                    onClick={() => {
                                        setNewAngle({
                                            id: 0,
                                            angle: "",
                                            visualizertype_id: "",
                                            default_grain_id: "",
                                            default_style_type_id: "",
                                            baseImage: null,
                                            svgImage: null,
                                            status: "Active"
                                        });
                                        setShowModal(true);
                                    }}
                                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
                                >
                                    Add Angle
                                </button>
                            </div>

                            {/* Table */}
                            <div className="p-6">
                                <div className="overflow-x-auto">
                                    <table className="min-w-full border-collapse bg-white rounded-lg shadow-md">
                                        <thead>
                                            <tr className="bg-gray-100 text-gray-800">
                                                <th className="text-start p-3 font-medium">ID</th>
                                                <th className="text-start p-3 font-medium">Angle Name</th>
                                                <th className="text-start p-3 font-medium">Base Image</th>
                                                <th className="text-start p-3 font-medium">SVG Image</th>
                                                {/* <th className="text-start p-3 font-medium">Grain Type</th>
                                                <th className="text-start p-3 font-medium">Style Type</th> */}
                                                <th className="text-start p-3 font-medium">Status</th>
                                                <th className="text-start p-3 font-medium">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentAngles?.length > 0 ? (
                                                currentAngles.map((angle) => (
                                                    <tr key={angle.id} className="border-b hover:bg-gray-50">
                                                        <td className="p-3">{angle.id}</td>
                                                        <td
                                                            className="p-3 text-blue-600 hover:underline cursor-pointer"
                                                            onClick={() =>
                                                                navigate(`/admin/colordetail/${angle.visualizer_id}`, {
                                                                    state: { angleId: angle.id },
                                                                })
                                                            }
                                                        >
                                                            {angle.name}
                                                        </td>
                                                        <td className="p-3">
                                                            {angle.base_image ? (
                                                                <img
                                                                    src={angle.base_image}
                                                                    alt="Base"
                                                                    className="w-16 h-16 object-cover rounded shadow hover:scale-105 transition cursor-pointer"
                                                                    onClick={() => openModal(angle.base_image)}
                                                                />
                                                            ) : (
                                                                <span className="text-gray-400 text-sm italic">No Image</span>
                                                            )}
                                                        </td>

                                                        <td className="p-3">
                                                            {angle.svg_image ? (
                                                                <a
                                                                    href={angle.svg_image}
                                                                    // download
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="text-blue-600 hover:underline"
                                                                >
                                                                    Download SVG
                                                                </a>
                                                            ) : (
                                                                <span className="text-gray-400 text-sm">No SVG</span>
                                                            )}
                                                        </td>

                                                        <td className="p-3">{angle.status === true ? 'Active' : 'Inactive'}</td>
                                                        <td className="p-3 align-middle">
                                                            <div className="flex items-center  gap-2 h-full">
                                                                <button onClick={() => handleEditClick(angle)} title="Edit Angle">
                                                                    <FaEdit color="red" />
                                                                </button>
                                                                <button
                                                                    onClick={() => {
                                                                        setRowToDuplicate(angle);
                                                                        setShowDuplicateModal(true);
                                                                    }}
                                                                    title="Duplicate Angle"
                                                                >
                                                                    <IoDuplicate />
                                                                </button>
                                                                <button
                                                                    onClick={() => setAngleToDelete(angle.id)}
                                                                    title="Delete Angle"
                                                                >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        className="w-5 h-5 text-red-500 hover:text-red-600"
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        stroke="currentColor"
                                                                    >
                                                                        <path d="M3 6h18M19 6l-1 14H6L5 6M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M10 11v6M14 11v6" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="p-4 text-center text-gray-500">
                                                        No angles found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                    {apiData?.VisualizerAngles?.length > itemsPerPage && (
                                        <div className="flex justify-center items-center gap-4 mt-4">
                                            <button
                                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                disabled={currentPage === 1}
                                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50"
                                            >
                                                <GrPrevious />
                                            </button>

                                            <span className="text-gray-700">
                                                Page {currentPage} of {totalPages}
                                            </span>

                                            <button
                                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                disabled={currentPage === totalPages}
                                                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50"
                                            >
                                                <GrNext />
                                            </button>
                                        </div>
                                    )}

                                </div>
                            </div>

                            {/* Add Angle Modal */}
                            {showModal && (
                                <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center">
                                    <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-xl overflow-auto h-[90%]">
                                        <h2 className="text-lg font-semibold text-gray-800 mb-4">{newAngle.id === 0 ? 'Add New Angle' : 'Edit Angle'}</h2>
                                        <div className="space-y-4">
                                            {/* Angle Name */}
                                            <div>
                                                <label className="block text-gray-700 mb-1">Angle Name</label>
                                                <input
                                                    type="text"
                                                    placeholder='Enter angle name'
                                                    value={newAngle.angle}
                                                    onChange={(e) => {
                                                        setNewAngle({ ...newAngle, angle: e.target.value });
                                                        setErrors({ ...errors, angle: '' }); // Clear error when user types
                                                    }}
                                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-400"
                                                />
                                                {errors.angle && <p className="text-red-500 text-xs">{errors.angle}</p>}
                                            </div>

                                            {/* Default Grain */}
                                            <div className="relative z-0 w-full mb-1 group">
                                                <label className="block text-gray-700 mb-1">Grain Type</label>
                                                <GrainDropDown
                                                    value={newAngle.default_grain_id}
                                                    onGrainSelect={(value) => {
                                                        handleGrainSelect(value);
                                                        setErrors({ ...errors, default_grain_id: '' }); // Clear error when user selects
                                                    }}
                                                    name="default_grain_id"
                                                    className={`block py-3 mt-3 px-0 w-full text-sm text-gray-900 bg-transparent border border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600 peer`}
                                                />
                                                {errors.default_grain_id && <p className="text-red-500 text-xs italic">{errors.default_grain_id}</p>}
                                            </div>

                                            {/* Default Style */}
                                            <div className="relative z-0 w-full mb-1 group">
                                                <label className="block text-gray-700 mb-1">Style Type</label>
                                                <StyleTypeDropDown
                                                    value={newAngle.default_style_type_id}
                                                    onStyleSelect={(value) => {
                                                        handleStyleTypeSelect(value);
                                                        setErrors({ ...errors, default_style_type_id: '' }); // Clear error when user selects
                                                    }}
                                                    name="default_style_type_id"
                                                    className={`block py-3 mt-3 px-0 w-full text-sm text-gray-900 bg-transparent border border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600 peer`}
                                                />
                                                {errors.default_style_type_id && <p className="text-red-500 text-xs italic">{errors.default_style_type_id}</p>}
                                            </div>

                                            {/* Base Image */}
                                            <div>
                                                <label className="block text-gray-700 mb-1">Base Image</label>

                                                {/* If a new file is uploaded */}
                                                {newAngle.baseImage && (
                                                    <div className="mb-2">
                                                        <img
                                                            src={URL.createObjectURL(newAngle.baseImage)}
                                                            alt="Uploaded Base Image"
                                                            className="w-28 h-auto object-contain mb-1"
                                                        />
                                                    </div>
                                                )}

                                                {/* If editing existing image */}
                                                {!newAngle.baseImage && newAngle.baseImagePath && (
                                                    <div className="mb-2">
                                                        <img
                                                            src={newAngle.baseImagePath}
                                                            alt="Existing Base Image"
                                                            className="w-28 h-auto object-contain rounded shadow"
                                                        />
                                                    </div>
                                                )}

                                                <input
                                                    type="file"
                                                    accept=".png,.webp"
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file) {
                                                            const allowedTypes = ['image/webp', 'image/png'];
                                                            if (!allowedTypes.includes(file.type)) {
                                                                toast.error("Only .webp and .png files are allowed for base image");
                                                                return;
                                                            }

                                                            setNewAngle({ ...newAngle, baseImage: file });
                                                            setErrors({ ...errors, baseImage: "" });
                                                        }
                                                    }}
                                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                                                />
                                                <p className="text-xs text-gray-500 mt-1">Allowed file types: .webp, .png</p>
                                                {errors.baseImage && <p className="text-red-500 text-xs">{errors.baseImage}</p>}
                                            </div>




                                            {/* SVG Image */}
                                            <div>
                                                <label className="block text-gray-700 mb-1">SVG Image</label>

                                                {/* If new SVG uploaded */}
                                                {newAngle.svgImage && (
                                                    <div className="mb-2">
                                                        <img
                                                            src={URL.createObjectURL(newAngle.svgImage)}
                                                            alt="Uploaded SVG"
                                                            className="w-28 h-auto object-contain mb-1"
                                                        />
                                                        {/* <p className="text-xs text-gray-500">New SVG preview</p> */}
                                                    </div>
                                                )}

                                                {/* If editing existing SVG */}
                                                {!newAngle.svgImage && newAngle.svgImagePath && (
                                                    <div className="mb-2">
                                                        <a
                                                            href={newAngle.svgImagePath}
                                                            download
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-600 hover:underline text-sm"
                                                        >
                                                            Download SVG Image
                                                        </a>
                                                        {/* <img
                                                            src={newAngle.svgImagePath}
                                                            alt="Existing SVG"
                                                            className="w-28 h-auto object-contain mt-1"
                                                        /> */}
                                                    </div>
                                                )}

                                                <input
                                                    type="file"
                                                    accept=".svg"
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file && file.type !== "image/svg+xml") {
                                                            toast.error("Only SVG files are allowed for SVG image");
                                                            return;
                                                        }
                                                        setNewAngle({ ...newAngle, svgImage: file });
                                                        setErrors({ ...errors, svgImage: "" });
                                                    }}
                                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                                                />
                                                <p className="text-xs text-gray-500 mt-1">Only .svg files are supported</p>
                                                {errors.svgImage && <p className="text-red-500 text-xs">{errors.svgImage}</p>}
                                            </div>


                                            {/* Status */}
                                            <div className="flex items-center space-x-2 mt-2">
                                                <input
                                                    type="checkbox"
                                                    id="status"
                                                    checked={newAngle.status === "Active"}
                                                    onChange={(e) =>
                                                        setNewAngle({ ...newAngle, status: e.target.checked ? "Active" : "Inactive" })
                                                    }
                                                    className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
                                                />
                                                <label htmlFor="status" className="text-gray-700">Active</label>
                                            </div>

                                            {/* Buttons */}
                                            <div className="flex justify-end gap-3 mt-4">
                                                <button
                                                    onClick={() => setShowModal(false)}
                                                    className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={handleAddAngle}
                                                    className="px-4 py-2 bg-teal-500 text-white rounded hover:bg-teal-600"
                                                >
                                                    {newAngle.id === 0 ? 'Add Angle' : 'Update Angle'}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            )}

                            {angleToDelete && (
                                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                                    <div className="bg-white p-8 rounded-xl shadow-lg text-gray-800">
                                        <p className="text-lg mb-6">Are you sure you want to delete this angle?</p>
                                        <div className="flex gap-4 justify-center">
                                            <button
                                                className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600"
                                                onClick={() => handleDeleteAngle(angleToDelete)}
                                            >
                                                Yes
                                            </button>
                                            <button
                                                className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400"
                                                onClick={() => setAngleToDelete(null)}
                                            >
                                                No
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}


                            {showDuplicateModal && (
                                <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center">
                                    <div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-xl">
                                        <h2 className="text-lg font-semibold text-gray-800 mb-4">Duplicate this Angle?</h2>
                                        <p className="text-gray-600 mb-6">Do you want to create a copy of this angle?</p>
                                        <div className="flex justify-end gap-4">
                                            <button
                                                onClick={() => setShowDuplicateModal(false)}
                                                className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
                                            >
                                                No
                                            </button>
                                            <button
                                                onClick={() => handleDuplicateAngle(rowToDuplicate?.id)}

                                                className="bg-teal-500 text-white px-4 py-2 rounded hover:bg-teal-600"
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {modalImage && (
                                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                                    <div className="relative bg-white p-6 rounded-xl shadow-lg">
                                        <img src={modalImage} alt="Full View" className="max-w-full max-h-[80vh] rounded-lg" />
                                        <button
                                            onClick={() => setModalImage(false)}
                                            className="absolute top-3 right-3 bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-red-600"
                                        >
                                            X
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AngleView;
